import { APICall } from "@/config/NetworkUtility";
import { logApiError } from "@/services/apiErrorLogger";
import { createAsyncThunk } from "@reduxjs/toolkit";

/* ==========================================
   GET SUB NAVIGATIONS
========================================== */

export const getSubNavigations = createAsyncThunk(
  "subNavigation/getSubNavigations",
  async (payload, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams(
        Object.entries(payload || {}).reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            acc[key] = value;
          }
          return acc;
        }, {}),
      ).toString();

      const url = `v1/NavigationSetup/GetSubNavigationList?${queryParams}`;

      const result = await APICall("get", payload, url);

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return {
          data: result?.data || [],
          pagination: result?.pagination || {},
        };
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "subNavigation",
        endpoint: "getSubNavigations",
        payload,
      });

      return rejectWithValue(error);
    }
  },
);

/* ==========================================
   CREATE BASE NAVIGATION
========================================== */

export const createSubNavigation = createAsyncThunk(
  "subNavigation/createSubNavigation",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await APICall(
        "post",
        payload,
        "v1/NavigationSetup/SubNavigationInsert",
      );

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return result;
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "subNavigation",
        endpoint: "createSubNavigation",
        payload,
      });

      return rejectWithValue(error);
    }
  },
);

/* ==========================================
   UPDATE BASE NAVIGATION
========================================== */

export const updateSubNavigation = createAsyncThunk(
  "subNavigation/updateSubNavigation",
  async (payload, { rejectWithValue }) => {
    try {
      const result = await APICall(
        "post",
        payload,
        "v1/NavigationSetup/SubNavigationUpdate",
      );

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return result;
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "subNavigation",
        endpoint: "updateSubNavigation",
        payload,
      });

      return rejectWithValue(error);
    }
  },
);
